<app-cards-list [cardslist]="calculatorList" />